import { render, staticRenderFns } from "./InvitationForm.vue?vue&type=template&id=1d787851&scoped=true&"
import script from "./InvitationForm.vue?vue&type=script&lang=js&"
export * from "./InvitationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d787851",
  null
  
)

export default component.exports